export default __webpack_public_path__ + "static/media/talhoes.098fd83f.svg";